export const DIRECT_AUTHENTICATION_TYPE = 1
export const CONFIRM_VALUE_AUTHENTICATION_TYPE = 2
export const PROVE_EMAIL_AUTHENTICATION_TYPE = 3
export const PROVIDE_EMAIL_AUTHENTICATION_TYPE = 4
export const PROVIDE_AND_PROVE_EMAIL_AUTHENTICATION_TYPE = 5
